import { Stack } from '@mui/material'
import ApproveDisabled from '../resources/images/approve_disabled.svg'
import ApproveActive from '../resources/images/approve_active.svg'
import CancelSvg from '../resources/images/cancel.svg'
import './ValidationRectangle.scss'

interface IValidationRectangle {
    onApprove: Function
    onCancel: Function
    disabled: boolean
}

function ValidationRectangle(props: IValidationRectangle) {
  return <Stack direction="row" className='Rectangle'>
        {props.disabled ? <img src={ApproveDisabled} alt='approved-dis' className='ValidationBtn' /> :
        <img data-testid="wizard-config-name-approve-btn" src={ApproveActive} alt='approved-act' className='ValidationBtn' onClick={()=>props.onApprove()} />}
        <img data-testid="wizard-config-name-cancel-btn" src={CancelSvg} alt='cancel-btn' className='ValidationBtn' onClick={()=>props.onCancel()} />
  </Stack>
}

export default ValidationRectangle